import { Component, Input, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Region } from '@app/api-module/control-centre-api-client';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';
import { Subscription } from 'rxjs';
import { ClinicalFeedbackConstants } from 'src/app/clinical-feedback/clinical-feedback-constants';

@Component({
    selector: 'app-duty-of-candour-form',
    templateUrl: './duty-of-candour-form.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]]
        }
    ]
})
export class DutyOfCandourFormComponent implements OnInit, OnDestroy {
    @Input() accessionNumber!: string;
    @Input() region?: Region;
    formControlName = 'dutyOfCandour';
    formGroup!: UntypedFormGroup;
    formElementModels = {};

    private readonly subscriptions = new Subscription();
    clinicalFeedbackConstants = ClinicalFeedbackConstants;

    constructor(public parent: FormGroupDirective, private readonly formBuilder: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.formElementModels = {
            supportFromEverlight: new FormElementModel({
                id: 'supportFromEverlight',
                fieldName: 'SuppportFromEverlight',
                label: 'What do you need from us to support the meeting (from Everlight/Reporting radiologist)',
                placeholder: 'Add text'
            }),
            lessonsLearnt: new FormElementModel({
                id: 'lessonsLearnt',
                fieldName: 'LessonsLearnt',
                label: 'Are there any lessons learnt for Everlight/Reporting Radiologist from the Duty of Candour meeting?',
                placeholder: 'Add text'
            }),
            copyOfSiReport: new FormElementModel({
                id: 'copyOfSiReport',
                fieldName: `Copy of the ${this.region === Region.Uki ? 'SI/PSI' : 'SI'} report`,
                label: `Please provide a copy of the ${this.region === Region.Uki ? 'SI/PSI' : 'SI'} report (if available)`
            })
        };

        this.formGroup = this.formBuilder.group({
            dateOfMeeting: [null],
            supportFromEverlight: [''],
            lessonsLearnt: [''],
            copyOfSiReport: [[]]
        });
        (this.parent.form.get('advisedSeriousIncident') as UntypedFormGroup).addControl(this.formControlName, this.formGroup);
    }

    ngOnDestroy() {
        //if a formGroup already exists in the parent when ngOnInit runs, new formGroup wouldn't work properly
        (this.parent.form.get('advisedSeriousIncident') as UntypedFormGroup).removeControl(this.formControlName);
        this.subscriptions.unsubscribe();
    }
}
